/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetContentLocationListResponse } from '../../models/get-content-location-list-response';

export interface GetContentLocations$Params {

/**
 * ID stránky
 */
  id: number;
}

export function getContentLocations(http: HttpClient, rootUrl: string, params: GetContentLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<GetContentLocationListResponse>> {
  const rb = new RequestBuilder(rootUrl, getContentLocations.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetContentLocationListResponse>;
    })
  );
}

getContentLocations.PATH = '/admin/content/{id}/location';
